export default "__VITE_ASSET__Dmb0hrhF__"